var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        { staticClass: "mr-2", attrs: { "no-gutters": "" } },
        [
          _c("v-col", [
            _c("label", { staticClass: "font-weight-light" }, [
              _vm._v("Persona adicional en sitio")
            ]),
            _c("br"),
            _c("small", [
              _vm._v(
                "Debe seleccionar un contacto autorizado de la lista de contactos"
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "block-click", attrs: { cols: "6", sm: "7" } },
            [
              _c(
                "v-row",
                { staticClass: "mr-2" },
                [
                  _c(
                    "v-col",
                    {},
                    [
                      _c("v-text-field", {
                        attrs: {
                          readonly: "",
                          label: "Nombre",
                          "prepend-icon": "mdi-account",
                          rules: [
                            _vm.rules.required(),
                            _vm.rules.fieldLength(50),
                            _vm.rules.specialCharacters(),
                            _vm.rules.allowLettersExclusively()
                          ]
                        },
                        model: {
                          value: _vm.authorizedPerson.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.authorizedPerson, "firstName", $$v)
                          },
                          expression: "authorizedPerson.firstName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mr-2" },
                [
                  _c(
                    "v-col",
                    {},
                    [
                      _c("v-text-field", {
                        attrs: {
                          readonly: "",
                          label: "Apellido",
                          "prepend-icon": "mdi-account",
                          rules: [
                            _vm.rules.required(),
                            _vm.rules.fieldLength(50),
                            _vm.rules.specialCharacters(),
                            _vm.rules.allowLettersExclusively()
                          ]
                        },
                        model: {
                          value: _vm.authorizedPerson.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.authorizedPerson, "lastName", $$v)
                          },
                          expression: "authorizedPerson.lastName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mr-2" },
                [
                  _c(
                    "v-col",
                    {},
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "########",
                            expression: "'########'"
                          }
                        ],
                        attrs: {
                          readonly: "",
                          label: "Cédula de Identidad",
                          rules: [_vm.rules.required()],
                          "prepend-icon": "mdi-card-account-details"
                        },
                        model: {
                          value: _vm.authorizedPerson.idNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.authorizedPerson, "idNumber", $$v)
                          },
                          expression: "authorizedPerson.idNumber"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mr-2" },
                [
                  _c(
                    "v-col",
                    {},
                    [
                      _c("phone-field", {
                        attrs: {
                          readonly: "",
                          "phone-data": _vm.authorizedPerson.telephoneNumber,
                          label: "Teléfono"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6", sm: "5" } },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "overflow-hidden",
                  staticStyle: { position: "relative" },
                  attrs: { height: "350" }
                },
                [
                  _c("Directory", {
                    attrs: {
                      size: 22,
                      maxHeight: 10,
                      modalCheck: _vm.modalCheck,
                      contactToDisplay: 10,
                      selectedValuesProp: _vm.selectedValuesProp
                    },
                    on: { contactClicked: _vm.getContactSelected }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }